import React, { useState, useEffect } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "./ExportToExcel";
import Pagination from "./CustomPagination";
import SearchBar from "./SearchBar";
import htmlComponent from "./HtmlComponent";

const ReusableTable = ({
  url,
  pagination,
  data,
  columns,
  defaultColumns,
  itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleEdit,
  handleEmployeeReview,
  handleManagerReview,
  isAddEmployeeReq,
  isAddManagerReq,
}) => {
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns({
      ...visibleColumns,
      [columnName]: !visibleColumns[columnName],
    });
  };

  const handlePageChange = (pageNumber) => {
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  return (
    <div>
      <div className="d-flex justify-content-between mt-1">
        <div className="col-lg-2 mb-3 mb-md-0 me-1">
          <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
        {/* <button className="me-1" id="excel-btn">
                    <ExportToExcel data={filteredData} filename="tableData.xlsx" />
                </button> */}
        <div className="d-flex gap-2">
          <div className="btn-group">
            <button
              type="button"
              className="dropdown-toggle skill-button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              id="excel-btn"
            >
              <i className="bi bi-list"></i>
            </button>

            <ul className="dropdown-menu p-2">
              <div className="row">
                <Form.Group>
                  {Object.keys(visibleColumns).map((columnName) => (
                    <Form.Check
                      key={columnName}
                      type="checkbox"
                      id={`checkbox-${columnName}`}
                      label={columnName} //custom column name
                      checked={visibleColumns[columnName]}
                      onChange={() => toggleColumn(columnName)}
                    />
                  ))}
                </Form.Group>
              </div>
            </ul>
          </div>
          <div>
            {isAddEmployeeReq && (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-top">Add Employee Review</Tooltip>
                }
              >
                <button id="Add-btn" onClick={handleEmployeeReview}>
                  <i className="fa fa-plus"></i>
                </button>
              </OverlayTrigger>
            )}
          </div>

          <div>
            {isAddManagerReq && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-top">Add Manager Review</Tooltip>}
              >
                <button id="Add-btn" onClick={handleManagerReview}>
                  <i className="fa fa-plus"></i>
                </button>
              </OverlayTrigger>
            )}
          </div>
        </div>
      </div>
      <div className="box-body table-responsive">
        <Table striped bordered hover>
          <thead id="thcolor" className="text-center">
            <tr>
              {Object.keys(columns).map(
                (columnName) =>
                  visibleColumns[columnName] && (
                    <th
                      key={columnName}
                      style={{
                        cursor: "pointer",
                        width: columns[columnName].width,
                      }}
                    >
                      {columns[columnName].text}
                    </th>
                  )
              )}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentData.map((item, index) => (
              <tr className="text-center" key={index}>
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn =
                    columns[columnName].text.toLowerCase().includes("doj") ||
                    columns[columnName].text.toLowerCase().includes("joining");
                  const isEmpName = columns[columnName].text
                    .toLowerCase()
                    .includes("employee name");
                  let is_html = isHTML(item[columnName]);
                  if (is_html) {
                    return (
                      <>
                        <td
                          dangerouslySetInnerHTML={{ __html: item[columnName] }}
                        ></td>
                      </>
                    );
                  }
                  return (
                    visibleColumns[columnName] && (
                      <td
                        className={`${isDateColumn ? "text-center" : ""} ${
                          isEmpName ? "text-start" : ""
                        }`}
                        key={columnName}
                      >
                        {item[columnName]}
                      </td>
                    )
                  );
                })}
                <td>
                  <div className="d-flex justify-content-center">
                    <div
                      className=" icons me-2"
                      onClick={() => handleEdit(item)}
                    >
                      <i className="bi bi-pencil-square"></i>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="d-flex justify-content-end">
          <Pagination
            url={url}
            itemsPerPage={pagination.perPage}
            totalItems={pagination.total}
            currentPage={pagination.currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ReusableTable;

function isHTML(str) {
  var a = document.createElement("div");
  a.innerHTML = str;

  for (var c = a.childNodes, i = c.length; i--; ) {
    if (c[i].nodeType == 1) return true;
  }

  return false;
}
